import { Box } from "@mui/material";
import clsx from "clsx";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useAppStore } from "../../../../../../hooks/useStores.tsx";
import Icons from "../../../../../components/Icons/index.ts";
import { DesignEditorContext } from "../../../../../contexts/DesignEditor.tsx";
import useSmartImageHeader from "../../../../../hooks/useSmartImageHeader.tsx";
import FabricObjectsProperties from "../../Panels/panelItems/Common/FabricObjectsProperties/FabricObjectsProperties.tsx";
import styles from "./StaticPath.module.scss";

const StaticPath = () => {
	const { isPopupView } = useContext(DesignEditorContext);
	const { handleDeleteSmartImage } = useSmartImageHeader();
	const { uiStore } = useAppStore();
	const { t } = useTranslation("translation", { keyPrefix: "editor" });

	return (
		<Box
			className={clsx({
				[styles.container]: true,
				[styles.hide]: isPopupView,
			})}
		>
			<Box
				className={clsx({
					[styles.staticPathControlsContainer]: true,
					[styles.noMarginRight]: uiStore.showGuideSection,
				})}
			>
				<Box onClick={handleDeleteSmartImage} className={styles.StaticPathControlsWrapper}>
					<Icons.Delete size={20} />
					<span className={styles.deleteLabel}>{t("delete")}</span>
				</Box>
				<FabricObjectsProperties />
			</Box>
		</Box>
	);
};

export default StaticPath;
